import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, removeLocalData } from "../../Helpers/authHelper";

const ProtectedRoute = () => {
  const isLoggedIn = isAuthenticated();
  if (!isLoggedIn) {
    removeLocalData();
     return <Navigate to="/login" />; // Redirect to login if not logged in
  }

  return <Outlet />;
};

export default ProtectedRoute;
